import styled from '@emotion/styled'
import { Button } from '@mui/material'

export const DemoButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: '#23b7e5',
  '&:hover': {
    backgroundColor: '#19a9d5',
  },
}))

export const ResetButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: '#f05050',
  '&:hover': {
    backgroundColor: '#ee3939',
  },
}))